// extracted by mini-css-extract-plugin
export default {"container":"FO-z","darkBackground":"GO-z","whiteBackground":"HO-z","headerButton":"IO-z","calloutHeading":"JO-z","calloutSubHeading":"KO-z"};